import React from 'react'
import PropTypes from 'prop-types'

import { useTranslation } from 'react-i18next'
import { Separator, H3 } from '@fs/zion-ui'
import EditableCoverages from './components/editableCoverages/EditableCoverages'
import { useCoverages } from '../../hooks'
import { useOverlayContext } from '../../../../../shared/providers/overlayContextProvider/OverlayContext'
import CoverageList from '../../components/CoverageList/CoverageList'

export default function Coverages({ forVolumeSet, editable = false }) {
  const [t] = useTranslation()
  const { coverages = [] } = useCoverages()
  const {
    infoSheetOverlay: { isBottomSheet },
  } = useOverlayContext()

  if (editable) return <EditableCoverages forVolumeSet={forVolumeSet} />
  if (coverages.length < 1) return null

  return (
    <>
      <Separator size="xxs" />
      <H3 size="H6">{t('coverages.image-group-contents.title', 'Image Group Contents')}</H3>
      <CoverageList coverages={coverages} isBottomSheet={isBottomSheet} />
    </>
  )
}

Coverages.propTypes = {
  forVolumeSet: PropTypes.bool,
  editable: PropTypes.bool,
}
